import BaseRepository from '@/api/repositories/BaseRepository';

class CustomerRepository extends BaseRepository {
	get endpoint() {
		return 'api/customers';
	}
}

export default new CustomerRepository();
